import { render } from "./ItemInfo.vue?vue&type=template&id=09ad531a&scoped=true&ts=true"
import script from "./ItemInfo.vue?vue&type=script&lang=ts"
export * from "./ItemInfo.vue?vue&type=script&lang=ts"

import "./ItemInfo.vue?vue&type=style&index=0&id=09ad531a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ad531a"]])

export default __exports__